import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Operations from '../../../operations'
import Selectors from '../../../selectors'
import { sizes } from '@lmc/common/constants'
import { HeaderSection, Spinner } from '../../../components/generic'
import ResidentStockItem from './components/ResidentStockItem'
import SuccessMessage from './components/SuccessMessage'

export function StockAlertsReportScreen(props) {
  const { fetchMedications, isLoading, stockReport } = props

  React.useEffect(() => {
    fetchMedications()
  }, [])

  if (isLoading || !stockReport) return <Spinner />

  const showSuccess = stockReport.length === 0

  return (
    <div style={styles.container}>
      <HeaderSection title="Stock Levels" />
      <div style={styles.bodyContainer}>
        {showSuccess ? (
          <SuccessMessage />
        ) : (
          stockReport.map(({ resident, emarResidentMeds }) => (
            <ResidentStockItem
              key={resident.id}
              resident={resident}
              emarResidentMeds={emarResidentMeds}
            />
          ))
        )}
      </div>
    </div>
  )
}

StockAlertsReportScreen.propTypes = {
  fetchMedications: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  stockReport: PropTypes.array.isRequired,
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
    position: 'relative',
  },
  bodyContainer: { paddingTop: 12 },
  filterContainer: {
    display: 'flex',
    marginTop: 16,
  },
}

const mapStateToProps = (state, props) => ({
  stockReport: Selectors.getStockLevelReport(state),
  preferredPeopleNominative: state.global.home.preferredPeopleNominative,
  isLoading: !state.data['emar-resident-medications'] || !state.data.residents,
})

const mapDispatchToProps = (dispatch) => ({
  fetchMedications: () =>
    dispatch(Operations.loadList('emar-resident-medications', { stock: true })),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockAlertsReportScreen)
